import Image from "./Image"

export default {
  File: Image
}
